import { render, staticRenderFns } from "./SidebarSearchProduct.vue?vue&type=template&id=71616a1d&scoped=true"
import script from "./SidebarSearchProduct.vue?vue&type=script&lang=js"
export * from "./SidebarSearchProduct.vue?vue&type=script&lang=js"
import style0 from "./SidebarSearchProduct.vue?vue&type=style&index=0&id=71616a1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71616a1d",
  null
  
)

export default component.exports